import { render } from "./notificationItems.vue?vue&type=template&id=71f1c11c&scoped=true"
import script from "./notificationItems.vue?vue&type=script&lang=js"
export * from "./notificationItems.vue?vue&type=script&lang=js"

import "./notificationItems.vue?vue&type=style&index=0&id=71f1c11c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f1c11c"]])

export default __exports__